import { useTranslation } from "react-i18next";

import "../styles/FooterComponent.css";

const FooterComponent = () => {
  const { t } = useTranslation();

  return (
    <div className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <h2>ASR-CERTPERS</h2>
        </div>
        <div className="footer-right">
          <p>
            &copy; {new Date().getFullYear()} {t("all_rights_reserved_footer")}.
          </p>
          <p className="footer-contact">
            {t("contact_us_footer")}:
            <a
              href="mailto:office@asrcertpers.ro"
              target="_blank"
              rel="noopener noreferrer"
            >
              office@asrcertpers.ro
            </a>
            <a
              href="mailto:ceo@asrcertpers.ro"
              target="_blank"
              rel="noopener noreferrer"
            >
              ceo@asrcertpers.ro
            </a>
            <a
              href="mailto:cto@asrcertpers.ro"
              target="_blank"
              rel="noopener noreferrer"
            >
              cto@asrcertpers.ro
            </a>
            <a
              href="mailto:asr@asrcertpers.ro"
              target="_blank"
              rel="noopener noreferrer"
            >
              asr@asrcertpers.ro
            </a>
            <a
              href="mailto:isim@asrcertpers.ro"
              target="_blank"
              rel="noopener noreferrer"
            >
              isim@asrcertpers.ro
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
export default FooterComponent;
